import { auth } from './firebase';
import { contentLoopApiConfig } from '@config/app.config';

// Bridges the admin review UI to the content-loop review Cloud Functions
// (functions/lib/content_loop/review.js). The dlh_* collections deny all
// client Firestore access by design (firestore.rules) — every read/write
// goes through these admin-gated HTTP endpoints instead.

async function authedFetch(url, options = {}) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('You must be signed in as an admin to manage the content loop.');
  }
  const idToken = await user.getIdToken();

  const res = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
      ...(options.headers || {}),
    },
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Request failed with status ${res.status}`);
  }
  return data;
}

/**
 * List dlh_items awaiting a human decision (draft/needs_review), each
 * joined with its source idea's topic/language.
 * @returns {Promise<Array<object>>}
 */
export async function listReviewItems() {
  const data = await authedFetch(contentLoopApiConfig.listReviewItemsUrl);
  return data.items || [];
}

/**
 * Approve or reject one dlh_items doc. Approving creates (or reuses,
 * idempotently) one dlh_publishJobs doc; rejecting does not.
 * @param {string} itemId
 * @param {"approve"|"reject"} action
 */
export async function reviewItem(itemId, action) {
  return authedFetch(contentLoopApiConfig.reviewItemUrl, {
    method: 'POST',
    body: JSON.stringify({ itemId, action }),
  });
}
